module.exports = __webpack_public_path__ + "static/img/qi_1.12dd0f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qi_1.jpg
// module id = eoG0
// module chunks = 1